// extracted by mini-css-extract-plugin
export default {"root":"TransferCodeModal-module--root--f4f15","tabs":"TransferCodeModal-module--tabs--ac88b","footer":"TransferCodeModal-module--footer--ad22c"};